import { MemberFee } from 'src/modules/member/models/memberFee';
import { MemberFeeRequest } from 'src/modules/member/models/memberFeeRequest';
import { setPagingParams } from '../functions/createPagingParams';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'Memberfee';

export const getMemberfeesByMemberIds = (pageIndex, pageSize, sortCol, sortDir, memberIds, invoiceTemplateId, withFamilyMembers) => {
  let extraQuery = '';
  if (memberIds && memberIds.length > 0) {
    memberIds.forEach((x) => {
      extraQuery += `&memberIds=${x}`;
    });
  }

  if (withFamilyMembers !== undefined) {
    extraQuery += `&withFamilyMembers=${withFamilyMembers}`;
  }

  const endpoint = `${controller}/?${setPagingParams({
    pageIndex,
    pageSize,
    sortCol,
    sortDir,
  })}${extraQuery}&invoiceTemplateId=${invoiceTemplateId}`;
  return AxiosInstance.get<PagedResult<MemberFee>>(endpoint);
};

export const createMemberFee = (data: MemberFeeRequest) => {
  return AxiosInstance.post<MemberFeeRequest>(controller, data);
};
